/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type {
  SpreadLibTester,
  SpreadLibTesterInterface
} from '../SpreadLibTester'

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'timeLastLongTransaction',
            type: 'uint128'
          },
          {
            internalType: 'int128',
            name: 'minLongTradePrice',
            type: 'int128'
          },
          {
            internalType: 'uint128',
            name: 'timeLastShortTransaction',
            type: 'uint128'
          },
          {
            internalType: 'int128',
            name: 'maxShortTradePrice',
            type: 'int128'
          }
        ],
        internalType: 'struct SpreadLib.Info',
        name: '_info',
        type: 'tuple'
      },
      {
        internalType: 'bool',
        name: '_isLong',
        type: 'bool'
      },
      {
        internalType: 'int256',
        name: '_price',
        type: 'int256'
      },
      {
        internalType: 'uint128',
        name: '_timestamp',
        type: 'uint128'
      }
    ],
    name: 'getUpdatedPrice',
    outputs: [
      {
        internalType: 'int256',
        name: 'updatedPrice',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [],
    name: 'info',
    outputs: [
      {
        internalType: 'uint128',
        name: 'timeLastLongTransaction',
        type: 'uint128'
      },
      {
        internalType: 'int128',
        name: 'minLongTradePrice',
        type: 'int128'
      },
      {
        internalType: 'uint128',
        name: 'timeLastShortTransaction',
        type: 'uint128'
      },
      {
        internalType: 'int128',
        name: 'maxShortTradePrice',
        type: 'int128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class SpreadLibTester__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SpreadLibTester> {
    return super.deploy(overrides || {}) as Promise<SpreadLibTester>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): SpreadLibTester {
    return super.attach(address) as SpreadLibTester
  }
  connect(signer: Signer): SpreadLibTester__factory {
    return super.connect(signer) as SpreadLibTester__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): SpreadLibTesterInterface {
    return new utils.Interface(_abi) as SpreadLibTesterInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SpreadLibTester {
    return new Contract(address, _abi, signerOrProvider) as SpreadLibTester
  }
}
